import ApiService from "@/core/services/api.service";

// action types
export const UPDATE_PERSONAL_INFO = "updateUserPersonalInfo";
export const INIT_INFO = "initInfo";
export const VERIFY_USER = "verifyUser";
export const UPDATE_CELLPHONE_REQUEST = "updateCellphoneRequest";
export const UPDATE_CELLPHONE_SUBMIT = "updateCellphoneSubmit";
export const UPDATE_PASSWORD_REQUEST = "updatePasswordRequest";
export const UPDATE_PASSWORD_SUBMIT = "updatePasswordSubmit";

// mutation types
export const SET_PERSONAL_INFO = "setPersonalInfo";
export const SET_CELLPHONE = "setCellphone";
export const SET_OPERATOR = "setOperator";

const state = {
  user_personal_info: {
    id: "",
    photo: "/media/users/blank.png",
    first_name: "",
    last_name: "",
    email: "",
    email_verified_at: "",
    cellphone: "",
    balance: 0
  },
  operator: {}
};

const getters = {
  currentUserPersonalInfo(state) {
    return state.user_personal_info;
  },
  currentUserOperator(state) {
    return state.operator;
  }
};

const actions = {
  [UPDATE_PERSONAL_INFO](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.put("profile", payload)
        .then(({ data }) => {
          context.commit(SET_PERSONAL_INFO, data);
          context.commit(SET_OPERATOR, data.operator);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },

  [INIT_INFO](context, payload) {
    context.commit(SET_PERSONAL_INFO, payload);
    context.commit(SET_OPERATOR, payload.operator);
  },

  [VERIFY_USER](context) {
    return new Promise(resolve => {
      ApiService.get("profile").then(({ data }) => {
        context.commit(SET_PERSONAL_INFO, data);
        context.commit(SET_OPERATOR, data.operator);
        resolve(data);
      });
    });
  },
  [UPDATE_CELLPHONE_REQUEST](context, payload) {
    return ApiService.patch("profile/cellphone", payload).then(({ data }) => {
      return data;
    });
  },

  [UPDATE_CELLPHONE_SUBMIT](context, payload) {
    return ApiService.post("profile/cellphone/otp", payload).then(
      ({ data }) => {
        context.commit(SET_CELLPHONE, data.cellphone);
        return data;
      }
    );
  },

  [UPDATE_PASSWORD_REQUEST](context, payload) {
    return ApiService.patch("profile/password", payload).then(({ data }) => {
      return data;
    });
  },

  [UPDATE_PASSWORD_SUBMIT](context, payload) {
    return ApiService.post("profile/password/otp", payload).then(({ data }) => {
      return data;
    });
  }
};

const mutations = {
  [SET_PERSONAL_INFO](state, payload) {
    state.user_personal_info = {
      id: payload.id,
      photo: "/media/users/blank.png",
      first_name: payload.first_name,
      last_name: payload.last_name,
      email: payload.email,
      email_verified_at: payload.email_verified_at,
      cellphone: payload.cellphone,
      balance: ""
    };
  },
  [SET_CELLPHONE](state, cellphone) {
    state.user_personal_info.cellphone = cellphone;
  },
  [SET_OPERATOR](state, operator) {
    if (operator) {
      state.operator = operator;
    }
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
